module.exports = {
    VALIDATION: {
        DEFAULT: 'Неправильне значення поля',
        REQUIRED: 'Це поле є обов\'язковим, будь-ласка заповніть його',
        MAX_LENGTH: 'Перевищено максимальну кількість символів',
        MIN_LENGTH: 'Мінімальна кількість символів {{value}}',
        EMAIL: 'Неправильне значення email',
        PHONE: 'Неправильне значення телефону',
        URL: 'Неправильне значення адреси сайту',
        SHARE_OVERFLOW:'The total share value cannot be greater than 100%',
        SHARE_LOW:'The total share value cannot be less than 100%'
    }
};


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/translate/translations/ua/error.ts